import request from "@/utils/request.js"
let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)


export function getContractList(parm){
    console.log("parm的值是：")
    console.log(parm)
    let tt1 = parm.tt1
    let tt2 = parm.tt2
    if( tt1=== undefined || tt1 == null || tt1 == "") {
        console.log("开始时间为空")
    } else {
        if(typeof tt1 === 'string'){
            console.log(tt1)
        } else {
            tt1=parm.tt1.format("YYYY-MM-DD")
        }  
    }
    if(tt2 === undefined || tt1 == null || tt1 == "") {
        console.log("结束时间为空")
    } else {
        if(typeof tt2 === 'string'){
            console.log(tt2)
        } else {
            tt2=parm.tt2.format("YYYY-MM-DD")
        }  
    }
    parm = {...parm,cmpid:user.cmpid,tt1,tt2}
    return request.get("/contract",{
        params:parm
    })
}

export function getCailiaodanlist(parm){
	parm = {...parm,cmpid:user.cmpid}
    return request.get("/contract/cailiaodan",{
        params:parm
    })
}

export function sunhao(parm){
    return request.put("/contract/sunhao",{
        data:{...parm,cmpid:user.cmpid}
    })
}

/**
 *获取上一个班组信息 
 */
export function getlastgroupinfo(parm){
	return request.get("/contract/lastsinfo",{
	    params:parm
	})
}

/**
 * 获取班组的预支单总金额 
 */
export function getbanzuyuzhisum(parm){
	return request.get("/contract/banzuyuzhisum",{
	    params:parm
	})
}
/**
 * 获取地址信息 
 */
export function getaddressinfo(parm){
	return request.post("/contract/addressinfo",{
	    data:parm
	})
}

/**
 *报销费用 
 */
export function baoxiaofei(parm){
	return request.get("/contract/baoxiaofei",{
	    params:parm
	})
}
/**
 *材料费用
 */
 export function cailiaofei(parm){
	return request.get("/contract/cailiaofei",{
	    params:parm
	})
}

export function getlastscan(parm){
	return request.get("/contract/lastscan",{
	    params:parm
	})
}

export function createjiesuan(parm){
    return request.post("/contract/createjiesuan",{
        data:parm
    })
}


/**
 * 检测身份证号 和 姓名 是否匹配 
 */
export function checkident(parm){
    return request.post("/contract/checkident",{
        data:parm
    })
}

/**
 * 拨款 
 */
export function bokuanreq(parm){
    return request.post("/contract/bokuan",{
        data:parm
    })
}

export function checkall(parm){
    return request.post("/contract/checkall",{
        data:parm
    })
}

export function addContract(parm){
    return request.post("/contract",{
        data:parm
    })
}

export function multiout(parm){
    return request.put("/contract/multiout",{
        data:parm
    })
}
export function updateContract(parm){
    return request.put("/contract",{
        data:{...parm,cmpid:user.cmpid}
    })
}

export function detialContract(parm){
    return request.get("/contract/detial",{
        params:parm
    })
}

export function tongbureq(parm){
	parm = {...parm,cmpid:user.cmpid}
	return request.get("/contract/tongbu",{
	    params:parm
	})
}

export function exportall(parm){
	return request.get("/contract/export",{
	    params:parm
	})
    }
export function deleteContract(parm){
    return request.delete("/contract",{
        params:parm
    })
}
export function muldel(parm){
    return request.delete("/contract/mul",{
        params:parm
    })
}